/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A SIP created from a Transfer
 * @export
 * @interface SIP
 */
export interface SIP {
    /**
     * 
     * @type {string}
     * @memberof SIP
     */
    appraisedSystemId?: string;
    /**
     * 
     * @type {number}
     * @memberof SIP
     */
    fileCount?: number;
    /**
     * 
     * @type {string}
     * @memberof SIP
     */
    highestSecurityGrading?: string;
    /**
     * 
     * @type {string}
     * @memberof SIP
     */
    highestSensitivityClassification?: string;
    /**
     * 
     * @type {string}
     * @memberof SIP
     */
    itemId?: string;
    /**
     * 
     * @type {string}
     * @memberof SIP
     */
    itemName?: string;
    /**
     * 
     * @type {string}
     * @memberof SIP
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof SIP
     */
    packageId?: number;
    /**
     * Identifier of SIP
     * @type {string}
     * @memberof SIP
     */
    sipId: string;
    /**
     * 
     * @type {string}
     * @memberof SIP
     */
    status: SIPStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof SIP
     */
    statusUpdatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof SIP
     */
    totalSize?: number;
    /**
     * Identifier of transfer
     * @type {string}
     * @memberof SIP
     */
    transferId?: string;
}


/**
 * @export
 */
export const SIPStatusEnum = {
    Created: 'Created',
    Failed: 'Failed',
    Ingesting: 'Ingesting',
    PackagesCreated: 'Packages Created',
    Rejected: 'Rejected',
    Stored: 'Stored'
} as const;
export type SIPStatusEnum = typeof SIPStatusEnum[keyof typeof SIPStatusEnum];


/**
 * Check if a given object implements the SIP interface.
 */
export function instanceOfSIP(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sipId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "statusUpdatedAt" in value;

    return isInstance;
}

export function SIPFromJSON(json: any): SIP {
    return SIPFromJSONTyped(json, false);
}

export function SIPFromJSONTyped(json: any, ignoreDiscriminator: boolean): SIP {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'appraisedSystemId': !exists(json, 'appraised_system_id') ? undefined : json['appraised_system_id'],
        'fileCount': !exists(json, 'file_count') ? undefined : json['file_count'],
        'highestSecurityGrading': !exists(json, 'highest_security_grading') ? undefined : json['highest_security_grading'],
        'highestSensitivityClassification': !exists(json, 'highest_sensitivity_classification') ? undefined : json['highest_sensitivity_classification'],
        'itemId': !exists(json, 'item_id') ? undefined : json['item_id'],
        'itemName': !exists(json, 'item_name') ? undefined : json['item_name'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'packageId': !exists(json, 'package_id') ? undefined : json['package_id'],
        'sipId': json['sip_id'],
        'status': json['status'],
        'statusUpdatedAt': (new Date(json['status_updated_at'])),
        'totalSize': !exists(json, 'total_size') ? undefined : json['total_size'],
        'transferId': !exists(json, 'transfer_id') ? undefined : json['transfer_id'],
    };
}

export function SIPToJSON(value?: SIP | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'appraised_system_id': value.appraisedSystemId,
        'file_count': value.fileCount,
        'highest_security_grading': value.highestSecurityGrading,
        'highest_sensitivity_classification': value.highestSensitivityClassification,
        'item_id': value.itemId,
        'item_name': value.itemName,
        'name': value.name,
        'package_id': value.packageId,
        'sip_id': value.sipId,
        'status': value.status,
        'status_updated_at': (value.statusUpdatedAt.toISOString()),
        'total_size': value.totalSize,
        'transfer_id': value.transferId,
    };
}

